"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireWildcard(require("react"));

var _colr = _interopRequireDefault(require("./vendor/colr"));

var _Panel = _interopRequireDefault(require("./Panel"));

var _classNames = _interopRequireDefault(require("react-utils/classNames"));

var _colors = require("HubStyleTokens/colors");

var computeHue = function computeHue(hex) {
  var hsv = _colr.default.fromHex(hex).toHsvObject();

  if (hsv.s === 0) return null;
  return hsv.h;
};

var computeColorWithHue = function computeColorWithHue(hex, hue) {
  var hsv = _colr.default.fromHex(hex).toHsvObject();

  if (hsv.s === 0) {
    return hex; // Hue has no effect on a color with no saturation.
  }

  return _colr.default.fromHsvObject((0, _extends2.default)({}, hsv, {
    h: hue
  })).toHex();
};

var ColorPicker =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(ColorPicker, _React$Component);

  function ColorPicker(props) {
    var _this;

    (0, _classCallCheck2.default)(this, ColorPicker);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(ColorPicker).call(this, props));
    _this.state = {
      hue: _colr.default.fromHex(props.color).toHsvObject().h
    };
    _this.handleChange = _this.handleChange.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  (0, _createClass2.default)(ColorPicker, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(_ref) {
      var hex = _ref.color;
      var computedHue = computeHue(hex);
      if (computedHue != null) this.setState({
        hue: computedHue
      });
    }
  }, {
    key: "handleChange",
    value: function handleChange(_ref2) {
      var alpha = _ref2.alpha,
          _ref2$hex = _ref2.hex,
          hex = _ref2$hex === void 0 ? this.props.color : _ref2$hex,
          hue = _ref2.hue;
      var color = hex;

      if (hue != null) {
        var currentHue = computeHue(hex);

        if (currentHue == null) {
          this.setState({
            hue: hue
          });
        } else {
          color = computeColorWithHue(hex, hue);
        }
      }

      var changes = {};
      if (color != null) changes.color = color;
      if (alpha != null) changes.alpha = alpha;
      this.props.onChange(changes);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          alpha = _this$props.alpha,
          alphaClassName = _this$props.alphaClassName,
          boardClassName = _this$props.boardClassName,
          className = _this$props.className,
          hex = _this$props.color,
          colorsClassName = _this$props.colorsClassName,
          favorites = _this$props.favorites,
          fieldsetSize = _this$props.fieldsetSize,
          hexOnly = _this$props.hexOnly,
          includeAlpha = _this$props.includeAlpha,
          onBlur = _this$props.onBlur,
          onFocus = _this$props.onFocus,
          ribbonClassName = _this$props.ribbonClassName;
      var hue = this.state.hue;
      var classes = (0, _classNames.default)(className, 'private-react-colorpicker', {
        'private-react-colorpicker--with-alpha': includeAlpha,
        'private-react-colorpicker--hex-only': hexOnly
      });
      return _react.default.createElement(_Panel.default, {
        alphaClassName: alphaClassName,
        boardClassName: boardClassName,
        colorsClassName: colorsClassName,
        className: classes,
        includeAlpha: includeAlpha,
        hexOnly: hexOnly,
        favorites: favorites,
        fieldsetSize: fieldsetSize,
        alpha: alpha,
        hex: hex,
        hue: hue,
        onChange: this.handleChange,
        onBlur: onBlur,
        onFocus: onFocus,
        mode: this.props.mode,
        ribbonClassName: ribbonClassName
      });
    }
  }]);
  return ColorPicker;
}(_react.default.Component);

exports.default = ColorPicker;
ColorPicker.propTypes = {
  alpha: _react.PropTypes.number,
  alphaClassName: _react.PropTypes.string,
  boardClassName: _react.PropTypes.string,
  className: _react.PropTypes.string,
  color: _react.PropTypes.string.isRequired,
  colorsClassName: _react.PropTypes.string,
  favorites: _react.PropTypes.array,
  fieldsetSize: _Panel.default.propTypes.fieldsetSize,
  hexOnly: _react.PropTypes.bool,
  includeAlpha: _react.PropTypes.bool,
  mode: _react.PropTypes.oneOf(['RGB', 'HSL', 'HSB']),
  onBlur: _react.PropTypes.func,
  onChange: _react.PropTypes.func,
  onFocus: _react.PropTypes.func,
  ribbonClassName: _react.PropTypes.string
};
ColorPicker.defaultProps = {
  color: _colors.OLAF,
  includeAlpha: false,
  hexOnly: true,
  favorites: [],
  alpha: 100,
  onChange: function onChange() {
    return null;
  },
  onBlur: function onBlur() {
    return null;
  },
  onFocus: function onFocus() {
    return null;
  },
  style: {}
};
module.exports = exports.default;